var projectTimeline = {
	"Project timeline": "ไทม์ไลน์ของโครงการ",
	"None planned": "ไม่ได้วางแผนไว้",
	"1-3 months": "1-3 เดือน",
	"4-6 months": "4-6 เดือน",
	"7-12 months": "7-12 เดือน",
	"More than 1 year": "มากกว่า 1 ปี"
};

export { projectTimeline as default };
